import {userInfoMock, deviceInfoMock} from '@/constants/mock';
import {isInApp} from './mUtil';
import MgecApi from 'mgec-jssdk';

const win = window as any;
win.deviceInfo = null;
win.userInfo = null;

export default {
  getDeviceAndUserInfo() {
    return Promise.all([this.getDeviceInfo(), this.getUserInfo()]);
  },

  getDeviceInfo() {
    return new Promise(resolve => {
      if (isInApp()) {
        MgecApi.callhandler('getDeviceInfo', {}, (data: any) => {
          const rep = JSON.parse(data);
          win.deviceInfo = rep;
          resolve(rep);
        });
      } else if (process.env.NODE_ENV !== 'production') {
        if (location.href.indexOf('debug') != -1) {
          win.deviceInfo = deviceInfoMock;
          resolve(deviceInfoMock);
        }else{
          resolve({});
        }
      }else{
        resolve({});
      }
    });
  },
  getUserInfo() {
    return new Promise((resolve, reject) => {
      if (isInApp()) {
        MgecApi.callhandler('getUserInfo', {}, (data: any) => {
          const rep = data ? JSON.parse(data) : {};
          win.userInfo = rep;
          resolve(rep);
        });
      } else if (process.env.NODE_ENV !== 'production') {
        if (location.href.indexOf('debug') != -1) {
          win.userInfo = userInfoMock;
          resolve(userInfoMock);
        }
        else{
          resolve({});
        }
      }else{
       
        resolve({});
      }
    });
  },
};
